import { ApportDto, CreationVisitePdaDto, EidDataRecordDto, EtrangerDto, GetOrCreateBelgeInfoByEIdRequestDto, Langues, PlaquePersonneMoraleDto, SecondeResidenceDto } from "src/api/models";
import { DocumentToPrint } from "./pda-visites.service";

export namespace PDAVisites {

  // static readonly type = '[PDAVisites] ';
  // constructor() { }

  export class SearchBelge {
    static readonly type = '[PDAVisites] Search for belge';
    constructor(public nom: string, public annee: string) { }
  }

  export class SearchByBarcode {
    static readonly type = '[PDAVisites] Search by barcode';
    constructor(public barcode: string) { }
  }

  // export class SearchHorsZone {
  //   static readonly type = '[PDAVisites] Search for foreigner outer IC zone';
  //   constructor(public code: string) { }
  // }

  // export class SearchSecondeResidence {
  //   static readonly type = '[PDAVisites] Search for foreigner with second residence';
  //   constructor(public code: string) { }
  // }

  // export class SearchPersonneMorale {
  //   static readonly type = '[PDAVisites] Search for morale person';
  //   constructor(public code: string) { }
  // }

  export class GetBelge {
    static readonly type = '[PDAVisites] Get belge from id';
    constructor(public id: number) { }
  }

  export class GetBelgeByEid {
    static readonly type = '[PDAVisites] Get belge from eid';
    constructor(public eidData: GetOrCreateBelgeInfoByEIdRequestDto) { }
  }

  export class GetEtranger {
    static readonly type = '[PDAVisites] Get etranger from id';
    constructor(public id: number) { }
  }

  export class CreateEtranger {
    static readonly type = '[PDAVisites] Create etranger';
    constructor(public etranger: EtrangerDto) { }
  }

  export class GetVisiteurPP {
    static readonly type = '[PDAVisites] Get visiteur PP from id';
    constructor(public ppId: number) { }
  }

  export class GetVisiteurPM {
    static readonly type = '[PDAVisites] Get visiteur PM from id';
    constructor(public pmId: number) { }
  }

  export class GetSecondesResidences {
    static readonly type = '[PDAVisites] Get secondes residences from ppId';
    constructor(public personnePhysiqueId: number) { }
  }

  export class CreateSecondeResidence {
    static readonly type = '[PDAVisites] Create seconde residence';
    constructor(public secondeResidence: SecondeResidenceDto) { }
  }

  export class AssignSecondeResidence {
    static readonly type = '[PDAVisites] Assign seconde residence to pp';
    constructor(public secondeResidence: SecondeResidenceDto, public personnePhysiqueId: number) { }
  }

  export class CreateVisite {
    static readonly type = '[PDAVisites] Create visit';
    constructor(public creationVisitePdaDto: CreationVisitePdaDto) { }
  }

  export class GetVisite {
    static readonly type = '[PDAVisites] Get visit';
    constructor(public visiteId: number) { }
  }

  export class GetPersonnePhysiquePlaques {
    static readonly type = '[PDAVisites] Get plates for pp';
    constructor(public personnePhysiqueId: number) { }
  }

  export class GetPersonneMoralePlaques {
    static readonly type = '[PDAVisites] Get plates for pm';
    constructor(public personneMoraleId: number) { }
  }

  export class CreatePlaquePP {
    static readonly type = '[PDAVisites] create plate pp';
    constructor(public personnePhysiqueId: number, public numeroPlaque: string) { }
  }

  export class CreatePlaquePM {
    static readonly type = '[PDAVisites] create plate pm';
    constructor(public personneMoraleId: number, public plaquePersonneMorale: PlaquePersonneMoraleDto) { }
  }

  export class CreateRepresentant {
    static readonly type = '[PDAVisites] create representative';
    constructor(public personnePhysiqueId: number, public representantId: number) { }
  }

  export class AddApport {
    static readonly type = '[PDAVisites] Add apport';
    constructor(public visiteId: number, public apport: ApportDto) { }
  }

  export class DeleteApport {
    static readonly type = '[PDAVisites] Delete apport';
    constructor(public visiteId: number, public typeDechetId: number) { }
  }

  export class GetSoldeDonnerie {
    static readonly type = '[PDAVisites] Get solde donnerie';
    constructor(public personneId: number) { }
  }

  export class UpdateDonnerie {
    static readonly type = '[PDAVisites] Update donnerie';
    constructor(public visiteId: number, public value: number) { }
  }

  export class CloseVisite {
    static readonly type = '[PDAVisites] Close visit';
    constructor(public visiteId: number) { }
  }

  export class PrintDocument {
    static readonly type = '[PDAVisites] Print document';
    constructor(public personnePhysiqueId: number, public parcId: number, public typeOfDocument: DocumentToPrint, public langue: Langues) { }
  }

  export class DownloadDocument {
    static readonly type = '[PDAVisites] Download document';
    constructor(public personnePhysiqueId: number, public typeOfDocument: DocumentToPrint, public langue: Langues) { }
  }

  // export class GetByCode {
  //   static readonly type = '[PDAVisites] Get visitor by barcode (PM or PP)';
  //   constructor(public barcode: string) { }
  // }

  export class GetPersonneMorale {
    static readonly type = '[PDAVisites] Get personne morale from id';
    constructor(public id: number) { }
  }

  export class GetTypesDechetForParc {
    static readonly type = '[PDAVisites] Get all wastes types for parc Id';
    constructor(public parcId: number) { }
  }

  export class CleanStore {
    static readonly type = '[PDAVisites] Clean store';
    constructor() { }
  }

  export class SetEidRead {
    static readonly type = "[ControlPanel] Set eid read info";
    constructor(public eidData: EidDataRecordDto) {}
  }
}
